import Skeleton from "@material-ui/lab/Skeleton";
import Grid from "@material-ui/core/Grid";

const InputFrames = () => {
  return (
    <Grid container spacing={5}>
      <div
        style={{
          padding: "2rem",
          width: "100%",
          display: "flex",
          flexWrap: "wrap",
        }}
      >
        <Grid item xs={12} sm={6} style={{ paddingLeft: "1rem" }}>
          <Skeleton animation="wave" variant="text" height={60} />
        </Grid>
        <Grid item xs={12} sm={6} style={{ paddingLeft: "1rem" }}>
          <Skeleton animation="wave" variant="text" height={60} />
        </Grid>

        <Grid item xs={12} sm={6} style={{ paddingLeft: "1rem" }}>
          <Skeleton animation="wave" variant="text" height={60} />
        </Grid>
        <Grid item xs={12} sm={6} style={{ paddingLeft: "1rem" }}>
          <Skeleton animation="wave" variant="text" height={60} />
        </Grid>
      </div>
    </Grid>
  );
};

export default InputFrames;
